import { type FC } from "react";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { CourseWithGroupingType } from "store/selectors/types";

type MoveCoursesConfirmationModalProps = {
  courses: CourseWithGroupingType[];
  onConfirm: () => void;
  onCancel: () => void;
};

export const MoveCoursesConfirmationModal: FC<MoveCoursesConfirmationModalProps> = ({
  courses,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="mt-8 flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <div>{t("home.courses.move_courses_confirmation_label")}</div>

        <div className="flex flex-col gap-2 border-l-2 border-score-1">
          {courses.map((course) => (
            <div className="pl-4" key={course.id}>
              {course.code} {" - "}
              {course.groupingTitle}
            </div>
          ))}
        </div>

        <div>{t("home.courses.move_courses_confirmation_question")}</div>
      </div>

      <div className="flex w-full justify-end gap-2">
        <Button kind="white" size="s" title={t("common.cancel")} onClick={onCancel}>
          {t("common.cancel")}
        </Button>

        <Button
          kind="red"
          size="s"
          title={t("home.courses.move_courses_title")}
          onClick={onConfirm}
        >
          {t("home.courses.move_courses_title")}
        </Button>
      </div>
    </div>
  );
};
